import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import ProductCard from './ProductCard'
import Header from './../block/Header'
import LastOrder from './../block/LastOrder'
import AkciiSlyder from './../block/AkciiSlyder'

import { Menu, Search } from './Svg'
import Stories from 'stories-react'
import 'stories-react/dist/index.css'

// Обертка для AkciiSlyder, которая выносит Stories в портал
const AkciiSlyderWrapper = ({ slydes }) => {
  const [storiesVisible, setStoriesVisible] = React.useState(false)
  const [storiesMounted, setStoriesMounted] = React.useState(false)
  const [currentStories, setCurrentStories] = React.useState([])
  const [currentStoryIndex, setCurrentStoryIndex] = React.useState(0)

  // Добавляем стили для анимации при монтировании
  React.useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `
      .stories-overlay {
        transition: opacity 0.3s ease-in-out;
      }
      .stories-overlay-enter {
        opacity: 0;
      }
      .stories-overlay-enter-active {
        opacity: 1;
      }
      .stories-overlay-exit {
        opacity: 1;
      }
      .stories-overlay-exit-active {
        opacity: 0;
      }
    `
    document.head.appendChild(style)
    
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  const handleImageClick = (storys, index) => {
    if (storys && storys.length > 0) {
      setCurrentStories(storys)
      setCurrentStoryIndex(0)
      setStoriesMounted(true)
      setTimeout(() => setStoriesVisible(true), 10)
    }
  }

  const handleStoriesClose = () => {
    setStoriesVisible(false)
    setTimeout(() => {
      setStoriesMounted(false)
      setCurrentStories([])
      setCurrentStoryIndex(0)
    }, 300)
  }

  const changeStorys = (currentStories) => {
    const stories = []
    currentStories.map((story) => {
      if (story?.link != '') {
        var new_story = {
          type: story?.type,
          url: story?.url,
          duration: story?.duration,
          seeMore: (
            <div>
              <a className='bg-[#ff770d] text-white px-[20px] py-[10px] rounded-[20px]' target="_blank" href={story?.link}>{story?.link_text}</a>
            </div>
          )
        }
      } else {
        var new_story = {
          type: story?.type,
          url: story?.url,
          duration: story?.duration
        }
      }
      stories.push(new_story)
    })
    return stories
  }

  return (
    <>
      {/* Обычный слайдер - рендерится в обычном месте */}
      <AkciiSlyder 
        slydes={slydes} 
        onImageClick={handleImageClick}
      />

      {/* Stories через портал в body - всегда поверх всех элементов */}
      {storiesMounted && ReactDOM.createPortal(
        <div 
          className={`fixed inset-0 z-50 stories-overlay ${
            storiesVisible ? 'stories-overlay-enter-active' : 'stories-overlay-exit-active'
          }`}
          style={{
            opacity: storiesVisible ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out'
          }}
        >
          <Stories
            stories={changeStorys(currentStories)}
            currentIndex={currentStoryIndex}
            onAllStoriesEnd={handleStoriesClose}
            onClose={handleStoriesClose}
            classNames={{
              main: `bg-[#0000009e]`,
              progressContainer: `h-[5px]`,
              progressBarContainer: `h-[5px] bg-[#5A91FF]`,
              progressBar: `h-[5px]`,
              storyContainer: `storyContainerMy`
            }}
          />
        </div>,
        document.body
      )}
    </>
  )
}

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuExpanded: false,
      activeCategory: null,
      searchQuery: '',
      isDragging: false,
      startX: 0,
      scrollLeft: 0
    }
    this.categoryRefs = {}
    this.menuContainerRef = React.createRef()
    this.productsContainerRef = React.createRef()
    this.scrollContainerRef = React.createRef()
  }

  componentDidMount() {
    this.createCategoryRefs(this.props.menu)
    
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.addEventListener('scroll', this.handleScroll)
      this.scrollContainerRef.current.addEventListener('touchmove', this.handleTouchMove, { passive: false })
    }

    if( this.props.data?.template == 4 ) this.props.openProductWin( this.props.data?.product_id )
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.menu.length === 0 && this.props.menu.length > 0) {
      this.createCategoryRefs(this.props.menu)
    }

    if (this.state.activeCategory !== prevState.activeCategory && this.state.activeCategory !== null) {
      this.scrollActiveCategoryToCenter();
    }
  }

  componentWillUnmount() {
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.removeEventListener('scroll', this.handleScroll)
      this.scrollContainerRef.current.removeEventListener('touchmove', this.handleTouchMove)
    }
  }

  createCategoryRefs = (menu) => {
    menu.forEach((category) => {
      if (!this.categoryRefs[category.pagetitle]) {
        this.categoryRefs[category.pagetitle] = React.createRef()
      }
    })
  }

  scrollActiveCategoryToCenter = () => {
    const menuContainer = this.menuContainerRef.current;
    
    if (!menuContainer) return;
    
    const activeElement = menuContainer.querySelector('.active-category');
    
    if (activeElement) {
      const containerWidth = menuContainer.offsetWidth;
      const elementLeft = activeElement.offsetLeft;
      const elementWidth = activeElement.offsetWidth;
      
      menuContainer.scrollTo({
        left: elementLeft - (containerWidth / 2) + (elementWidth / 2),
        behavior: 'smooth'
      });
    }
  }

  handleScroll = () => {
    this.updateActiveCategoryOnScroll()
  }

  handleTouchMove = (e) => {
    const scrollContainer = this.scrollContainerRef.current
    if (!scrollContainer) return

    const scrollTop = scrollContainer.scrollTop
    const scrollHeight = scrollContainer.scrollHeight
    const clientHeight = scrollContainer.clientHeight

    // Если контент не превышает высоту контейнера — блокируем любой свайп вниз/вверх
    if (scrollHeight <= clientHeight) {
      e.preventDefault()
      return
    }

    // Если достигнут верх (scrollTop === 0) и пользователь тянет вниз — блокируем
    if (scrollTop === 0 && e.touches[0].screenY > (e._prevTouchY || e.touches[0].screenY)) {
      e.preventDefault()
      return
    }

    // Если достигнут низ и пользователь тянет вверх — блокируем
    if (scrollTop + clientHeight >= scrollHeight && e.touches[0].screenY < (e._prevTouchY || e.touches[0].screenY)) {
      e.preventDefault()
      return
    }

    e._prevTouchY = e.touches[0].screenY
  }

  updateActiveCategoryOnScroll = () => {
    const { menu } = this.props
    const scrollContainer = this.scrollContainerRef.current

    if (menu.length === 0 || !scrollContainer) return

    let closestCategory = null
    let closestDistance = Infinity

    menu.forEach((category, index) => {
      const ref = this.categoryRefs[category.pagetitle]
      if (ref?.current) {
        const containerRect = scrollContainer.getBoundingClientRect()
        const elementRect = ref.current.getBoundingClientRect()
        const relativeTop = elementRect.top - containerRect.top
        const distance = Math.abs(relativeTop)

        if (relativeTop <= 100 && distance < closestDistance) {
          closestDistance = distance
          closestCategory = index
        }
      }
    })

    if (closestCategory !== null && closestCategory !== this.state.activeCategory) {
      this.setState({ activeCategory: closestCategory })
    }
  }

  handleMouseDown = (e) => {
    const menuContainer = this.menuContainerRef.current
    if (!menuContainer) return

    this.setState({
      isDragging: true,
      startX: e.pageX - menuContainer.offsetLeft,
      scrollLeft: menuContainer.scrollLeft
    })

    menuContainer.style.cursor = 'grabbing'
    menuContainer.style.userSelect = 'none'
  }

  handleMouseLeave = () => {
    this.setState({ isDragging: false })
    const menuContainer = this.menuContainerRef.current
    if (menuContainer) {
      menuContainer.style.cursor = 'grab'
      menuContainer.style.removeProperty('user-select')
    }
  }

  handleMouseUp = () => {
    this.setState({ isDragging: false })
    const menuContainer = this.menuContainerRef.current
    if (menuContainer) {
      menuContainer.style.cursor = 'grab'
      menuContainer.style.removeProperty('user-select')
    }
  }

  handleMouseMove = (e) => {
    if (!this.state.isDragging) return
    
    const menuContainer = this.menuContainerRef.current
    if (!menuContainer) return

    e.preventDefault()
    const x = e.pageX - menuContainer.offsetLeft
    const walk = (x - this.state.startX) * 2
    menuContainer.scrollLeft = this.state.scrollLeft - walk
  }

  toggleMenu = () => {
    this.setState(prevState => ({
      isMenuExpanded: !prevState.isMenuExpanded
    }))
  }

  handleCategoryClick = (category, index) => {
    this.setState({
      isMenuExpanded: false,
      activeCategory: index
    })

    const ref = this.categoryRefs[category.pagetitle]
    const scrollContainer = this.scrollContainerRef.current
    
    if (ref?.current && scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect()
      const elementRect = ref.current.getBoundingClientRect()
      const scrollOffset = elementRect.top - containerRect.top + scrollContainer.scrollTop - 80
      
      scrollContainer.scrollTo({
        top: scrollOffset,
        behavior: 'smooth'
      })
    }
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value })
  }

  filterProducts = (products) => {
    const { searchQuery } = this.state
    if (!searchQuery.trim()) return products

    const query = searchQuery.toLowerCase()
    return products.filter(product => 
      product.pagetitle?.toLowerCase().includes(query) || 
      product.introtext?.toLowerCase().includes(query)
    )
  }

  render() {
    const { 
      menu, 
      favorite, 
      changeFavorite, 
      openProductWin,
      data,
      user,
      restaurant,
      showLocation,
      assets_path,
      lastOrder
    } = this.props
    const { isMenuExpanded, activeCategory, searchQuery } = this.state

    if(menu.length == 0) return (
      <div className='mt-[10px] w-[100%] min-h-[150px] flex items-center justify-center'>
        <div className="w-10 h-10 border-4 border-[#5A91FF] border-t-transparent rounded-full animate-spin"></div>
      </div>
    )

    return (
      <div className='h-screen flex flex-col overflow-hidden w-full'>
        <div className='bg-white w-full pb-[10px] rounded-b-[25px] shadow-[0px_4px_14.5px_0px_rgba(0,0,0,0.11)] container flex-none'>
          <Header
            user={user}
            restaurant={restaurant}
            data={data}
            leftMenu={this.props.leftMenu}
            showLocation={showLocation}
            bgWhie={true}
          />

          <div className='mt-[10px]'>
            <div className='bg-[#F6F6F6] text-black flex gap-[10px] items-center h-[40px] rounded-full mb-[10px] px-[10px]'>
              <Search />
              <input
                type='text'
                placeholder='Введите название блюда'
                className='flex-1 border-0 bg-[#F6F6F6] text-[#00000099] text-[16px]'
                value={searchQuery}
                onChange={this.handleSearchChange}
              />
            </div>
            <div className='flex items-start justify-start gap-[5px] w-[calc(100%+10px)] lg:w-full'>
              <div 
                className={`flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full cursor-pointer ${isMenuExpanded ? 'bg-[#5A91FF] bluebtn-shadow text-[#F6F6F6]' : 'bg-[#F6F6F6] text-black'}`}
                onClick={this.toggleMenu}
              >
                <Menu />
              </div>
              <div 
                ref={this.menuContainerRef}
                className={`scroll-bar-custom-hiden flex items-start gap-[5px] flex-1 overflow-x-auto cursor-grab active:cursor-grabbing ${isMenuExpanded ? 'flex-wrap overflow-visible' : ''}`}
                onMouseDown={this.handleMouseDown}
                onMouseLeave={this.handleMouseLeave}
                onMouseUp={this.handleMouseUp}
                onMouseMove={this.handleMouseMove}
              >
                {menu.map( (elm, index) => (
                  <div 
                    key={index}
                    className={`flex items-center gap-[9px] h-[40px] p-[5px] rounded-full cursor-pointer flex-shrink-0 ${activeCategory === index ? 'bg-[#5A91FF] bluebtn-shadow active-category' : 'bg-[#F6F6F6]'}`}
                    onClick={() => this.handleCategoryClick(elm, index)}
                  >
                    <div className='flex flex-none items-center justify-center w-[30px] h-[30px] rounded-full bg-white'>
                      {elm?.icon && elm.icon !== '' &&
                        <img src={elm?.icon} width={16} height={16} alt={elm.pagetitle} />
                      }
                    </div>
                    <div className={`text-[18px] me-[12px] text-nowrap tracking-tight ${activeCategory === index ? 'text-white' : 'text-black'}`}>{elm?.pagetitle}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div 
          ref={this.scrollContainerRef}
          className='flex-1 overflow-y-auto scroll-bar-custom w-full overflow-x-hidden'
        >
          <div className='container'>
            <LastOrder
              order={lastOrder}
              assets_path={assets_path}
            />
            
            {/* Заменяем AkciiSlyder на обертку, которая выносит Stories в портал */}
            <AkciiSlyderWrapper slydes={restaurant?.akcii || []} />

            {!data?.is_mobile_app &&
              <div className='mt-[15px] mb-[20px] flex items-center justify-between'>
                <a 
                  href="https://apps.apple.com/ru/app/окидоки-доставка-еды/id6753726483" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src={`/${assets_path}/images/apps/app-store-light.svg`} alt="App Store" />
                </a>
                <a 
                  href="https://play.google.com/store/apps/details?id=ru.pizzaokidoki.app" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src={`/${assets_path}/images/apps/google-play-light.svg`} alt="Google Play" />
                </a>
                <a 
                  href="https://www.rustore.ru/catalog/app/ru.pizzaokidoki.app" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src={`/${assets_path}/images/apps/rustore.svg`} alt="RuStore" />
                </a>
              </div>
            }

            <div className='pb-[120px]' ref={this.productsContainerRef}>
              {menu.map( (razdel, j) => {
                const filteredProducts = this.filterProducts(razdel.products || [])
                
                if (filteredProducts.length === 0 && searchQuery) {
                  return null
                }

                if(!razdel.loaded) return (
                  <div key={j} ref={this.categoryRefs[razdel.pagetitle]} className='mb-[5px] w-[100%] min-h-[100px] flex items-center justify-center'>
                    <div className="w-10 h-10 border-4 border-[#5A91FF] border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )

                return (
                  <div key={j} ref={this.categoryRefs[razdel.pagetitle]}>
                    {searchQuery == '' &&
                      <div className='text-center text-[22px] font-semibold mt-[10px] mb-[5px]'>{razdel.pagetitle}</div>
                    }
                    {filteredProducts.map( (elm, k) => (
                      <ProductCard
                        elm={elm}
                        key={k}
                        favorite={favorite}
                        changeFavorite={changeFavorite}
                        openProductWin={openProductWin}
                      />
                    ))}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  menu: PropTypes.array,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  openProductWin: PropTypes.func,
  user: PropTypes.object,
  restaurant: PropTypes.object,
  showLocation: PropTypes.func,
  assets_path: PropTypes.string,
  lastOrder: PropTypes.object,
  leftMenu: PropTypes.func
}

Main.defaultProps = {
  data: {},
  menu: [],
  favorite: []
}

export default Main